import {
  POPUPS_HIDE_INTRO_POPUPS,
  POPUPS_SHOW_SCENE_ERRORS,
  POPUPS_HIDE_SCENE_ERRORS,
  POPUPS_CONF_OPEN,
  POPUPS_CONF_CLOSE,
  POPUPS_CONF_CLEAR,
  POPUPS_RESET_INTRO,
  SCENE_ITEM_PICKED_UP,
  POPUPS_MOUNTING_RAIL_SHEET_OPEN,
  POPUPS_SUPPLY_BANNER_CLOSE,
  POPUPS_SET_HAS_SHOWN_FILTER_INTRO_POPUP,
  POPUPS_SET_FILTER_INTRO_POPUP_VISIBLE,
  POPUPS_OVERLAY_ACTIVE,
  POPUPS_SET_INTRO_POPUPS_VISIBLE,
  POPUPS_SET_CUTTABLE_MOUNTING_RAIL_HINT_CHECK_PENDING,
  POPUPS_SET_HAS_SHOWN_INTRO_POPUPS,
  POPUPS_SCROLL_EXCEPTION,
  POPUPS_HANDLE_POPUPS_ON_ADD_ITEM,
  POPUPS_HANDLE_POPUPS_ON_UPDATE_ITEM,
  POPUPS_SET_SURVEY_VISIBLE,
  POPUPS_SET_SURVEY_STATE,
  POPUPS_SET_ERROR_HANDLING_PENDING_TIMESTAMP,
} from '../actionConstants';
import { CustomAction, TacItem, RootAction } from '../../generalTypes';
import { SceneError } from './popupsTypes';

export const actionHideIntroPopups = (): RootAction => ({
  type: POPUPS_HIDE_INTRO_POPUPS,
});

export const actionShowSceneErrors = (
  errors: SceneError[]
): CustomAction<{ errors: SceneError[] }> => ({
  type: POPUPS_SHOW_SCENE_ERRORS,
  payload: {
    errors,
  },
});

export const actionHideSceneErrors = (): RootAction => ({
  type: POPUPS_HIDE_SCENE_ERRORS,
});

export const actionConfOpened = (): RootAction => ({ type: POPUPS_CONF_OPEN });

export const actionConfClosed = (
  closedId: number | undefined
): CustomAction<{ closedId: number | undefined }> => ({
  type: POPUPS_CONF_CLOSE,
  payload: {
    closedId,
  },
});

export const actionClearPreviousConf = (): RootAction => ({
  type: POPUPS_CONF_CLEAR,
});

export const resetIntroPopups = (): RootAction => ({
  type: POPUPS_RESET_INTRO,
});

export const actionItemPickedUp = (
  item: TacItem
): CustomAction<{ item: TacItem }> => ({
  type: SCENE_ITEM_PICKED_UP,
  payload: {
    item: item,
  },
});

export const mountingRailSheetOpened = (): RootAction => ({
  type: POPUPS_MOUNTING_RAIL_SHEET_OPEN,
});

export const actionSetSurveyVisible = (surveyVisible: boolean) => ({
  type: POPUPS_SET_SURVEY_VISIBLE,
  payload: { surveyVisible },
});

export const actionSetSurveyState = (surveyState: string) => ({
  type: POPUPS_SET_SURVEY_STATE,
  payload: { surveyState },
});

export const actionSetErrorHandlingPendingTimestamp = (
  errorHandlingPendingTimestamp: null | number
) => ({
  type: POPUPS_SET_ERROR_HANDLING_PENDING_TIMESTAMP,
  payload: { errorHandlingPendingTimestamp },
});

export const closeSupplyBanner = (): RootAction => ({
  type: POPUPS_SUPPLY_BANNER_CLOSE,
});

export const actionSetHasShownFilterIntroPopup = (
  hasShownFilterIntroPopup: boolean
) => ({
  type: POPUPS_SET_HAS_SHOWN_FILTER_INTRO_POPUP,
  payload: { hasShownFilterIntroPopup },
});

export const actionSetFilterIntroPopupBeVisible = (
  filterIntroPopupVisible: boolean
) => ({
  type: POPUPS_SET_FILTER_INTRO_POPUP_VISIBLE,
  payload: { filterIntroPopupVisible },
});

export const actionSetOverlayState = (
  state: boolean
): CustomAction<{ state: boolean }> => ({
  type: POPUPS_OVERLAY_ACTIVE,
  payload: {
    state,
  },
});

export const actionSetScrollException = (
  state: boolean
): CustomAction<{ state: boolean }> => ({
  type: POPUPS_SCROLL_EXCEPTION,
  payload: {
    state,
  },
});

export const actionSetIntroPopupsVisible = (introPopupsVisible: boolean) => ({
  type: POPUPS_SET_INTRO_POPUPS_VISIBLE,
  payload: {
    introPopupsVisible,
  },
});

export const actionSetCuttableMountingRailHintCheckPending = (
  cuttableMountingRailHintCheckPending: boolean
) => ({
  type: POPUPS_SET_CUTTABLE_MOUNTING_RAIL_HINT_CHECK_PENDING,
  payload: {
    cuttableMountingRailHintCheckPending,
  },
});

export const actionSetHasShownIntroPopups = () => ({
  type: POPUPS_SET_HAS_SHOWN_INTRO_POPUPS,
});

export const actionHandlePopupOnAddItem = (newValues: any) => ({
  type: POPUPS_HANDLE_POPUPS_ON_ADD_ITEM,
  payload: newValues,
});

export const actionHandlePopupOnUpdateItem = (newValues: any) => ({
  type: POPUPS_HANDLE_POPUPS_ON_UPDATE_ITEM,
  payload: newValues,
});
